<template>
  <div class="megaload-container d-flex flex-column justify-content-center align-items-center"
    :class="{ 'megaload-fullscreen': !noStyle }"
    role="alert">
    <h1 class="title">
      <img src="/images/mega_spinner.gif"
        alt="Loading Animation"
        class="spinner-img">
    </h1>
    <h2>
      {{ taunt }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'MegaLoad',

  props: {
    noStyle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      taunts: [
        'Chuck Norris ordered a Big Mac at Burger King, and got one.',
        'Chuck Norris doesn’t wear a watch. He decides what time it is.',
        'Chuck Norris can win a game of Connect Four in only three moves.',
        "Chuck Norris' Gmail address is gmail@chucknorris.com",
        'Chuck Norris is the reason why Waldo is hiding.',
        'Chuck Norris is currently suing NBC, claiming Law and Order are trademarked names for his left and right legs.',
        "Chuck Norris doesn't dial the wrong number. You answered the wrong phone.",
        'Chuck Norris can kill two stones with one bird.',
        'Chuck Norris does not sleep; he waits.',
        "Cam was 'ere",
        'Waiting for remote hands...',
        'Executing `rm -Rf /` on your machine',
        'Lorem ipsum dollarydoo',
        'Waiting for generic Chuck Norris quote...',
        'Waiting for Half Life 3...',
        'Waiting for cake day...',
        'Waiting for pie day...',
        'Doing coffee run...',
        'Waiting for OGMR RMA',
        "Luke was 'ere",
        'Checking OOB LTE data quota',
        'Waiting for GCX back-bone packet loss to clear ',
        'Restarting strongSwan',
        'Adjusting back-bone wave MTU',
        'Cleaning VNIC patching',
        'Varifying dignostics code with Stack Overflow community',
        'Parsing 6Wind BGP crash dumps',
        'Searching for Python 2.7 dependencies',
        'Checking IX whois-cache-updater is running',
        'Installing CrowdStrike update',
        'Waiting for Java code to compile...',
        'Chuck Norris threw a grenade and killed 50 people, then it exploded.',
        'Chuck Norris counted to infinity. Twice.',
        'Chuck Norris can strangle you with a cordless phone.',
        "Searching 'how to exit vim'",
        "Chuck Norris' calendar goes straight from March 31st to April 2nd. No one fools Chuck Norris.",
        "When a zombie apocalypse starts,  Norris doesn't try to survive. The zombies do.",
        "Chuck Norris's computer has no 'backspace' button, Chuck Norris doesn't make mistakes.",
        'Chuck Norris can delete the Recycling Bin.',
        'The following is a short list of things Chuck Norris cannot do: .',
        'The flu gets a Chuck Norris shot every year.',
      ],
    }
  },

  computed: {
    taunt: function() {
      return this.taunts[Math.floor(Math.random() * this.taunts.length)]
    },
  },
}
</script>

<style lang="scss" scoped>
.megaload-container {
  width: 100%;
  text-align: center;
}
.megaload-fullscreen {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-primary, #ffffff);
}
h2 {
  font-size: 1.3rem;
}
.spinner-img {
  max-width: 200px;
  height: auto;
}
</style>
